<template>
    <div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Tamano</label>
                <input class="form-control" type="number" :value="modelValue.size"
                    @input="updateNumber('size', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Espacio</label>
                <input class="form-control" type="number" :value="modelValue.gap"
                    @input="updateNumber('gap', $event.target.value)">
            </div>
        </div>
        <div class="mb-2 d-flex justify-content-between align-items-center">
            <label class="form-label m-0">Redes</label>
            <button class="btn btn-sm btn-outline-secondary" type="button" @click="addItem">Agregar</button>
        </div>
        <div v-for="(item, index) in modelValue.items" :key="index" class="border rounded p-2 mb-2">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <label class="form-label">Nombre</label>
                    <input class="form-control" type="text" :value="item.label"
                        @input="updateItem(index, 'label', $event.target.value)">
                </div>
                <div class="col-md-4 mb-2">
                    <label class="form-label">Icono URL</label>
                    <input class="form-control" type="text" :value="item.iconUrl"
                        @input="updateItem(index, 'iconUrl', $event.target.value)">
                </div>
                <div class="col-md-4 mb-2">
                    <label class="form-label">Link</label>
                    <input class="form-control" type="text" :value="item.url"
                        @input="updateItem(index, 'url', $event.target.value)">
                </div>
            </div>
            <button class="btn btn-sm btn-outline-danger" type="button" @click="removeItem(index)">Eliminar</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockSocialsEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
        updateNumber(key, value) {
            const num = Number(value);
            this.update(key, Number.isFinite(num) ? num : 0);
        },
        updateItem(index, key, value) {
            const items = Array.isArray(this.modelValue.items) ? [...this.modelValue.items] : [];
            const item = items[index] || { label: '', iconUrl: '', url: '' };
            items[index] = { ...item, [key]: value };
            this.update('items', items);
        },
        addItem() {
            const items = Array.isArray(this.modelValue.items) ? [...this.modelValue.items] : [];
            items.push({ label: 'Red', iconUrl: '', url: '#' });
            this.update('items', items);
        },
        removeItem(index) {
            const items = Array.isArray(this.modelValue.items) ? [...this.modelValue.items] : [];
            items.splice(index, 1);
            this.update('items', items);
        },
    },
};
</script>
